<template>
  <div class="loader">
    <img :src="logo" alt="logo loader" />
    <div class="spin"></div>
    <div class="text-center">Cargando Reporte ...</div>
  </div>
</template>
<script>
export default {
  data() {
    return { logo: require("@/assets/images/logo.png") };
  },
};
</script>

<style lang="css">
.spin,
.spin:after {
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.spin {
  background-color: transparent;
  border-top: 5px solid #ffb511;
  border-right: 5px solid #ffb511;
  border-bottom: 5px solid #ffb511;
  border-left: 5px solid #ffb41157;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-duration: 0.8s;
  animation-name: spinner-loading;
}
@keyframes spinner-loading {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}
</style>
